import { EstadoProspectoEnum, generateUUID, newProspectoCorporativoSchema, texto, TipoIdentificacionEnumChoice } from "@/shared";
import { useFetchParametros, useFetchSearchIdentification, usePostSolicitudLineaCorp } from "@/shared/actions/erp";
// import { useFetchBuroCredito } from "@/shared/actions/erp/global/buro-crediticio";
import { useFetchPutSolicitudCanje } from "@/shared/actions/erp/marketing";
import { useFetchPutSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import { usePostProspectoCorporativo, usePutProspectoCorporativo, validateSellByOtherUser } from "@/shared/actions/erp/prospecto_corporativo.actions";
import { IFromProspecto, TipoDocumentoNameEnum, EstadoContribuyenteRucENUM, AlertSeverityEnum, RangoEdadEnum, NacionalidadEnum, TipoSolicitudesEnum } from "@/shared/interfaces";
import { IProspectoCorporativo } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import { useAuthStore } from "@/store/auth";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { isAxiosError } from "axios";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

interface IEsCliente { alerta: boolean; nombre: string; linea: number | undefined; plan: string }

export const useProspectoCorporativo = (formulary?:any) => {

  const navigate = useNavigate();
  const { mutateAsync: putSolicitudCanje } = useFetchPutSolicitudCanje({})
  const { mutateAsync: putSolicitudEvento } = useFetchPutSolicitudEvento({})

  //USESTATE
  const [disableIdentification, setDisableIdentification] = useState<boolean>(false)
  const [esCliente, setEsCliente] = useState<IEsCliente>({ alerta: false, nombre: '', linea: 0, plan: '' });
  const [esDifunto, setEsDifunto] = useState<boolean>(false);
  const [esResidente, setEsResidente] = useState<boolean>(false);
  const [checkedResidencia, setcheckedResidencia] = useState<boolean>(true);
  // const [openPreviewSolicitud, setOpenPreviewSolicitud] = useState(false);

  const [modalProspectoEnProceso, setModalProspectoEnProceso] = useState<boolean>(false);
  const [dataProspectoEnProceso, setDataProspectoEnProceso] = useState<IProspectoCorporativo | null>(null);
  const [valorRestriccionCel, setValorRestriccionCel] = useState<any>({});


  //STORE
  const setAlert = useUiStore((s) => s.setAlert);
  const currentUser = useAuthStore((s) => s.user);
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const currentUsername = useAuthStore(s => s.user)?.username!

  //USEFORMULARIO


  const schemaProspectoCorporativoSchema = useMemo(
    () => newProspectoCorporativoSchema(valorRestriccionCel),
    [valorRestriccionCel]
  );

  const form = useForm<IProspectoCorporativo>({
    resolver: yupResolver(schemaProspectoCorporativoSchema as any),
    defaultValues: {
      tipo_identificacion: TipoIdentificacionEnumChoice.RUC
    }
  });

  const {
    reset,
    control,
    setError,
    formState: { errors },
  } = form;

  const watcherCondicionVenta = form.watch().condicion_venta


  const createProspectoMutation = usePostProspectoCorporativo({
    navigate
  });
  const { 
    mutateAsync:putProspectoCorporativo, 
    isPending: loadingUpdateProspectoCorporativo
     } = usePutProspectoCorporativo({enableAlert:true})

  /* const {
    data: dataSolicitudCanje,
    isLoading: isLoadingSolicitudCanje
  } = useFetchSolicitudCanje({
    identificacion: form.watch().identificacion_canje_evento
  }) */

  //FETCH
  // const { mutateAsync: mutateAsyncBuroCredito } = useFetchBuroCredito();

  const searchDataByIdentification = useFetchSearchIdentification({
    identificacion: form.watch().identificacion,
    enableSuccessAlert: false
  });

  const { data: dataParamRestriccionCel, isLoading: isLoadingParamRestriccionCel } = useFetchParametros({
    enabled: true,
    params: {
      slug: "RESTRICCION_CELULAR"
    }
  });

  useEffect(() => {
    if (!isLoadingParamRestriccionCel) {
      setValorRestriccionCel(
        dataParamRestriccionCel?.data?.data?.[0]?.valor 
        ? JSON.parse(dataParamRestriccionCel?.data?.data?.[0]?.valor) 
        : {}
      );
    }
  }, [isLoadingParamRestriccionCel, dataParamRestriccionCel])

  useEffect(() => {
    setDisableIdentification(false);
    if(formulary){
      reset({
        ...formulary,
      })
    }
  }, [])

  
  useEffect(() => {

    !!watcherCondicionVenta ?
      reset({
        ...form.getValues(),
        requiere_cotizacion: true
      })
      :
      reset({
        ...form.getValues(),
        requiere_cotizacion: false
      })

    //console.log(form.getValues())
  }, [watcherCondicionVenta]);

  // useEffect(() => {
  //   if(form.getValues()?.identificacion?.length==13){
  //     setIsGlobalLoading(true);
  //     fnBuscarIdentificacion(form.getValues()?.identificacion!)
  //   }
  // }, [form.getValues().identificacion]);

  /**
   * 
   * Enviar formulario para crear un prospecto
   * 
   * @param data 
   * 
   * @returns 
   */

  const onSubmit = async (data: IFromProspecto) => {


    const resp = await validateSellByOtherUser({ identificacion: data?.identificacion });
    const prospectosInfo = resp?.data;
    if (
      prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
      || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
    ) {
      return setAlert(
        true,
        "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
        AlertSeverityEnum.warning,
        4000
      );
    }

    if (form.getValues().tipo_identificacion === TipoDocumentoNameEnum.RUC
      && form.getValues().estado_contribuyente_ruc == EstadoContribuyenteRucENUM.SUSPENDIDO)
      return setAlert(true, 'Estado contribuyente suspendido', 'error');

    setIsGlobalLoading(true);

    if (!checkedResidencia) {
      setIsGlobalLoading(false);
      setAlert(true, texto.sin_condicion_residencia, AlertSeverityEnum.warning);
      return;
    }

    reset({
      ...form.getValues(),
      condicion_venta: !!form.getValues()?.condicion_venta ? form.getValues().condicion_venta : null
    })

    if (form.getValues().tipo_identificacion == TipoDocumentoNameEnum.RUC) {
      data.edad = RangoEdadEnum.EDAD_MINIMA
      data.residencia_permanente = checkedResidencia
      data.es_coorporativo = true
      data.observaciones = {
        observacion_vendedor: form.getValues().observacion_vendedor
      }

      if (data.solicitud_canje) {
        putSolicitudCanje({
          id_solicitud_canje: form.getValues()?.solicitud_canje_data?.id_solicitud_canje,
          canje_aplicado: true
        })
      }
      if (data.solicitud_evento 
        && form.getValues()?.condicion_venta != TipoSolicitudesEnum.EVENTO_PAGADO) {
        putSolicitudEvento({
          id_solicitud_evento: form.getValues()?.solicitud_evento_data?.id_solicitud_evento,
          evento_aplicado: true
        })
      }


      await createProspectoMutation.mutateAsync(data)
      setIsGlobalLoading(false)
      return
    }


  }



  /**
   * Funcion fnBuscarIdentificacion
   * 
   * Realiza una búsqueda asincrónica para obtener información basada en un número de identificación
  */
  const fnBuscarIdentificacion = async (identificacion: string) => {

    const resp = await validateSellByOtherUser({ identificacion: identificacion });
    const prospectosInfo = resp?.data;
    if (
      prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
      || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
    ) {
      setIsGlobalLoading(false)
      return setAlert(
        true,
        "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
        AlertSeverityEnum.warning,
        4000
      );
    }

    try {
      console.log({ identificacion })
      const e = await searchDataByIdentification.mutateAsync({
        identificacion: identificacion,
        verificar_cliente: true,
        es_corporativo: true,
      });
      if(e && (e?.data_antiguos_contratos?.length || 0) > 0){
        return setAlert(true, 'El RUC que trata de ingresar ya es cliente previo.', 'error',4000);
      }
      if(e?.tiene_prospecto){
        return setAlert(true, 'Ya existe un prospecto creado. Diríjase a la ventana de preventas para crear la nueva venta para el cliente requerido.', 'error',4000);
      }

      const data = e.data;

      if (e.code === 201) {
        let planeC = data.planes != null ? data.planes.map(e => e.nombre).join('\n') : 'N/A';
        setEsCliente({ alerta: true, linea: e.linea, nombre: data.razon_social, plan: planeC });
      } else {
        setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
      }

      setIsGlobalLoading(true);




      if (identificacion.length === 13) {

        setcheckedResidencia(true)

        reset({
          ...form.getValues(),
          nacionalidad: NacionalidadEnum.CODIGO,
          pais: NacionalidadEnum.CODIGO,
          razon_social: data.razonSocial,
          tipo_contribuyente: data.tipoContribuyente,
          estado_contribuyente_ruc: data.estadoContribuyenteRuc,
          regimen: data.regimen,
          actividad_economica_principal: data.actividadEconomicaPrincipal
        })
      }

      // const respBuroCredio = await mutateAsyncBuroCredito({
      //   identificacion: identificacion
      // });

      reset({
        ...form.getValues(),
        /* segmentacion: "TEST DATA",
        puntaje_score_empresa: 999,
        puntaje_score: 999,
        puntaje_score_sobreendeudamiento: 999, */
        // segmentacion: respBuroCredio.data.segmentacion,
        // puntaje_score_empresa: respBuroCredio.data.puntaje_score_empresa,
        // puntaje_score: respBuroCredio.data.puntaje_score,
        // puntaje_score_sobreendeudamiento: respBuroCredio.data.puntaje_score_sobreendeudamiento,
      })

    } catch (error) {

      //handleAxiosError(error)

      if (isAxiosError(error)) {



        const respError: any = error.response?.data || {};

        if (respError === 408) return setEsDifunto(true);

        if (respError.code == 407
          || respError.code == 500
          || error.code == 'ERR_NETWORK'
          || error.code == 'ERR_BAD_RESPONSE') {
          setConfirmDialogIsOpen(true);
          setConfirmDialog({
            isOpen: true,
            title: '¡Problemas al consultar con el SRI!',
            subtitle: `Los servicios de consulta al SRI no están disponibles en este momento. Mientras tanto, puedes ingresar los datos manualmente.`,
            confirmTextBtn: 'Confirmar',
            onClose() {
              setConfirmDialogIsOpen(false);
            },
            async onConfirm() {

              // const respBuroCredio = await mutateAsyncBuroCredito({
              //   identificacion: identificacion
              // });

              reset({
                ...form.getValues(),
                // segmentacion: respBuroCredio.data.segmentacion,
                // puntaje_score_empresa: respBuroCredio.data.puntaje_score_empresa,
                // puntaje_score: respBuroCredio.data.puntaje_score,
                // puntaje_score_sobreendeudamiento: respBuroCredio.data.puntaje_score_sobreendeudamiento,
                nacionalidad: NacionalidadEnum.CODIGO,
                pais: NacionalidadEnum.CODIGO,
              })

              setConfirmDialogIsOpen(false);
              setEsResidente(true);
              setcheckedResidencia(true);
            },
            cancelTextBtn: 'Cerrar',
          });
          return;
        }

        if (respError?.code == 409) {

          const listProspecto = respError.data as IProspectoCorporativo[];

          const prospectoEnEspera = listProspecto.find(e => e.estado_prospecto == EstadoProspectoEnum.EN_ESPERA);

          if (prospectoEnEspera) {
            setConfirmDialogIsOpen(true);

            setConfirmDialog({
              isOpen: true,
              title: '¡Prospecto EN ESPERA! ',
              subtitle:
                'Existe un prospecto EN ESPERA de gestión. Por favor, comunícate con tu asesor para obtener más información.',
              onConfirm() {
                setConfirmDialogIsOpen(false);
              },
              confirmTextBtn: 'Cerrar',
            });

            return;
          }

          const prospectoEnProceso = listProspecto.find(e => e.estado_prospecto == EstadoProspectoEnum.EN_PROCESO);

          if (prospectoEnProceso) {
            setDataProspectoEnProceso(prospectoEnProceso);
            setModalProspectoEnProceso(true)
            return;
          }

        }



      } else {
        //handleAxiosError(error)
      }

    } finally {
      setIsGlobalLoading(false);

    }
  }

  const {
    mutateAsync: mutateAsyncSolicitudLinea,
  } = usePostSolicitudLineaCorp({});

  const handleCrearSolicitudNuevaLinea = async () => {

    try {
      await mutateAsyncSolicitudLinea({
        identificacion: dataProspectoEnProceso?.identificacion!,
        estado_solicitud: EstadoProspectoEnum.EN_ESPERA,
        estado: true,
      });

      /* if (resp.code === 200) {
        window.location.reload();
      } */

    } catch (error) {

    } finally {
      setModalProspectoEnProceso(false)
    }

  }


  

  const handleOnSubmitUpdate= async(textWritten:string)=>{
    const respUpdate = await putProspectoCorporativo({
      id:form.getValues()?.id_prospecto_corporativo!,
      data:{
        historial_actualizaciones: 
        !!!form.getValues()?.historial_actualizaciones
        || form.getValues()?.historial_actualizaciones?.length==0?
        [{
          uuid:generateUUID(),
          content:textWritten,
          date:dayjs(new Date()).format("LLL"),
          created_by:currentUser?.razon_social||currentUser?.username||"user"
        }]
        : [...form.getValues()?.historial_actualizaciones!,
          {
            uuid:generateUUID(),
            content:textWritten,
            date:dayjs(new Date()).format("LLL"),
            created_by:currentUser?.razon_social||currentUser?.username||"user"
          } 
        ]
      }
    })
    if(!loadingUpdateProspectoCorporativo){
      form.reset({
        ...form.getValues(),
        historial_actualizaciones: respUpdate?.data.historial_actualizaciones
      })
    }
  }

  return {

    //state
    esDifunto,
    setEsDifunto,
    esCliente,
    setEsCliente,

    // openPreviewSolicitud, 
    // setOpenPreviewSolicitud,
    setDisableIdentification,
    disableIdentification,
    setAlert,
    setIsGlobalLoading,
    setEsResidente,
    setcheckedResidencia,
    esResidente,
    checkedResidencia,
    setModalProspectoEnProceso,
    modalProspectoEnProceso,
    dataProspectoEnProceso,
    setDataProspectoEnProceso,
    //form
    form,
    control,
    reset,
    errors,
    setError,

    //fn
    onSubmit,
    fnBuscarIdentificacion,
    handleCrearSolicitudNuevaLinea,
    // handleBuscarSolicitudCanje,
    // handleBuscarIconSolicitudCanje,
    // handleLimpiarSolicitudCanjeEvento,
    handleOnSubmitUpdate,
    ///* solicitud canje o evento
    // dataCanje,
    // dataEvento,
    // watcherCondicionVenta,
    //isLoadingSolicitudCanje,
    valorRestriccionCel

  }
}